import "./Loader.css";

import React from "react";

const Loader = () => {
  return (
    <>
      <div className="loading-wrapper">
        <div className="loading-spinner"></div>
      </div>
    </>
  );
};

export default Loader;
